<template>
  <div class="job-status-multi-check">
    <kt-autoselect
      :label="props.label"
      :options="statusOptions"
      display-by="Status"
      value-by="Id"
      :multiple="true"
      v-model="model"
      search-placeholder="Search status..."
      :on-refresh="handleRefresh"
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import KtAutoselect from '@/components/UI/KtAutoselect.vue';
import { useJobStatusStore } from '@/stores/JobStatusStore';
import type { JobStatusModel } from '@/models/JobStatusModel';

const props = defineProps({
  label: { 
    type: String, 
    default: 'Select Status' 
  }
});

const emit = defineEmits<{
  change: [value: number[]];
}>();

const model = defineModel<number[]>({
  default: () => []
});

const statusStore = useJobStatusStore();
const statusOptions = ref<JobStatusModel[]>([]);

// Load status options on mount
onMounted(async () => {
  await statusStore.load();
  // Convert Record to Array
  statusOptions.value = Object.values(statusStore.list) || [];
});

const handleChange = (value: number[]) => {
  emit('change', value);
};

const handleRefresh = async () => {
  await statusStore.refresh();
  // Convert Record to Array
  statusOptions.value = Object.values(statusStore.list) || [];
};
</script>
